export default __webpack_public_path__ + "static/media/fill-form.273c9104.svg";